export function getListItems(_a) {
    var tips = _a.tips, bottomTips = _a.bottomTips, options = _a.options, groups = _a.groups, allOption = _a.allOption;
    var items = [];
    // allOption
    if (allOption) {
        items.push({
            type: "option",
            key: allOption.value,
            text: typeof allOption.text === "undefined"
                ? allOption.value
                : allOption.text,
            option: allOption,
        });
    }
    // tips
    if (tips) {
        items.push({ type: "tips", key: "__tips", text: tips });
    }
    // option/group
    options.forEach(function (option, index) {
        if (option.groupKey &&
            (index === 0 || option.groupKey !== options[index - 1].groupKey)) {
            if (groups) {
                items.push({
                    type: "group",
                    key: option.groupKey + "-" + option.value,
                    text: groups[option.groupKey],
                });
            }
            else if (items.length > 0) {
                items.push({
                    type: "divider",
                    key: option.groupKey + "-" + option.value,
                    text: "",
                });
            }
        }
        items.push({
            type: "option",
            key: option.value,
            text: typeof option.text === "undefined" ? option.value : option.text,
            option: option,
        });
    });
    // bottomTips
    if (bottomTips) {
        items.push({ type: "tips", key: "__bottom_tips", text: bottomTips });
    }
    return items;
}
//# sourceMappingURL=util.js.map